import React from "react";
import { Outlet } from "react-router-dom";

import IdleSessionHandler from "@/Components/IdleSessionHandler";
import { selectAuthStatus } from "@/store/authSlice";
import { useAppSelector } from "@/store/hooks";

import AuthInitializer from "../auth/AuthInitializer";

const RouterRoot: React.FC = () => {
  const status = useAppSelector(selectAuthStatus);

  return (
    <>
      <AuthInitializer />
      <IdleSessionHandler />

      {status === "initializing" || status === "pending" ? (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white">
          <div className="text-lg font-semibold">Loading...</div>
        </div>
      ) : (
        <Outlet />
      )}
    </>
  );
};

export default RouterRoot;
